import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Tipo } from 'src/class/tipo';
import { newUsuario } from 'src/class/usuario';
import { CepService } from 'src/services/cep.service';
import { TipoService } from 'src/services/component/tipo.service';
import { ContadorIndexService } from 'src/services/contador-index.service';
import { DataService } from 'src/services/data.service';
import { SiglaService } from 'src/services/siglaService.service';
import { ToastService } from 'src/services/toast.service';
import { TranslateWordService } from 'src/services/translate-word.service';
import { UsuariosService } from 'src/services/usuarios.services';
import { ValidatorService } from 'src/services/validator.service';

declare var bootstrap: any;

@Component({
  selector: 'app-criar-tipo',
  templateUrl: './criar-tipo.component.html',
  styleUrls: ['./criar-tipo.component.css']
})
export class CriarTipoComponent implements OnInit {
  @ViewChild('alertTipoModal', { static: false }) alertTipoModal!: ElementRef;

  usr_id: string = "";
  usr_tipo: string = "";
  usr_token: string = "";

  usr_obj: any = [];

  usr_new = new newUsuario;

  tipo: Tipo = new Tipo();
  tipos: Tipo[] = [];
  empresaSigla: any | undefined;

  constructor(
    private router: Router,
    private usuarios: UsuariosService,
    private toast: ToastService,
    private validatorService: ValidatorService,
    private cepService: CepService,
    private translateWord: TranslateWordService,
    private contadorIndexService: ContadorIndexService,
    private tipoService: TipoService,
    private route: ActivatedRoute,
    private siglaService: SiglaService
  ){
    // Alimenta o serviço com a empresaSigla
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.route.params.subscribe(params => {
          this.empresaSigla = params['empresaSigla'];
          this.siglaService.setEmpresaSigla(this.empresaSigla?.toString());
        });
      }
    });
  }

  async ngOnInit() {
    try{
      const usr = JSON.parse(localStorage.getItem('user')!);
      // this.usr_id = usr.Id;
      // this.usr_tipo = usr.Tipo;
      // this.usr_token = usr.Token;
      this.usr_id = "1";
      this.usr_tipo = "M";
      this.usr_token = "usr.Token";
      if(this.usr_tipo != "M" && this.usr_tipo != "A"){
        this.router.navigate(['/home']);
      }
    }catch{
      this.router.navigate(['/home']);
    }
    // Agora você pode usar o ID como quiser

  }

  routerLink(rota: string, id: any = null){
    if(id != null){
      this.router.navigate([`${this.empresaSigla}/${rota}`, id]);
    }else{
      this.router.navigate([`${this.empresaSigla}/${rota}`]);
    }
  }

  async criarTipo(){
    this.tipo.nome.status = this.validatorService.criarValidacao(this.tipo.nome.valor, this.tipo.nome.validacoesCustomizadas);
    this.tipo.descricao.status = this.validatorService.criarValidacao(this.tipo.descricao.valor, this.tipo.descricao.validacoesCustomizadas);

    if(this.tipo.nome.status.invalid ||
      this.tipo.descricao.status.invalid
    ){
      this.abrirModal(this.alertTipoModal.nativeElement);
    }else{

      this.tipo.id = await this.contadorIndexService.contadorIndex();
      let new_tipo  = new Tipo();
      new_tipo = this.tipo;

      new_tipo.criado = new Date();
      new_tipo.atualizado = new Date();

      const tipo = JSON.stringify(new_tipo);
      const res = await this.tipoService.criarTipo(JSON.parse(tipo), this.empresaSigla)

      // this.showSuccess("Tipo criado com sucesso");
      this.tipo = new Tipo();
      this.router.navigate([`${this.empresaSigla}/tipos`]);
    }
  }

  abrirModal(event: any) {
    // Ativar o modal usando a biblioteca do Bootstrap
    const modal = new bootstrap.Modal(event);
    modal.show();
  }

  private showSuccess(msg: string){
    this.toast.showToast('<i class="bi bi-check-circle-fill " style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'success');
  }

  private showError(msg: string){
    this.toast.showToast('<i class="bi bi-x-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'danger');
  }

  private showInfo(msg: string) {
    this.toast.showToast('<i class="bi bi-info-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'info');
  }
}
